import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { debounce } from './_helpers'

gsap.registerPlugin(SplitText)

export default class LimitLines {
  constructor(el) {
    this.container = el
    this.limitLines = Number(this.container.dataset.limitLines)
    this.isOpen = Boolean(this.container.dataset.defaultOpen)
    this.showMoreText = this.container.dataset.showMoreText
    this.showLessText = this.container.dataset.showLessText
    this.animationDuration = 0.5
    this.setLinesToHide = this.setLinesToHide.bind(this)

    this.setHeight = this.setHeight.bind(this)
    this.addButton = this.addButton.bind(this)
    this.resize = this.resize.bind(this)
    this.setContainerLines = this.setContainerLines.bind(this)
    this.debouncedResize = debounce(this.resize, 100)

    this.init()
  }

  setContainerLines() {
    this.containerLines = new SplitText(this.container.children, {
      type: 'lines',
    })
  }

  setLinesToHide() {
    this.linesToHide = this.containerLines.lines.slice(
      -(this.containerLines.lines.length - this.limitLines)
    )
  }

  setHeight() {
    if (this.isOpen) {
      gsap.set(this.containerLines.lines, {
        display: 'initial',
      })
    } else {
      const tl = gsap.timeline()
      tl.set(this.linesToHide, {
        display: 'none',
      })
      tl.set(this.containerLines.lines[this.limitLines - 1], {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        width: 'calc(100% - 5rem)',
      })
    }
  }

  resize() {
    this.containerLines.revert()
    this.setContainerLines()
    this.setLinesToHide()
    this.setHeight()
  }

  setButtonText(button) {
    if (this.isOpen) {
      button.innerText = this.showLessText
    } else {
      button.innerText = this.showMoreText
    }
  }

  addButton() {
    const button = document.createElement('a')
    button.setAttribute('href', '#')
    button.classList.add('show-more-button')

    button.addEventListener('click', e => {
      e.preventDefault()
      this.isOpen = !this.isOpen
      this.setButtonText(button)
      this.setHeight()
    })

    this.setButtonText(button)
    this.container.parentNode.appendChild(button)
  }

  destroy() {
    window.removeEventListener('resize', this.debouncedResize)
  }

  init() {
    this.setContainerLines()
    this.setLinesToHide()
    this.addButton()
    this.setHeight()
    window.addEventListener('resize', this.debouncedResize)
  }
}
